import { APIRequestState } from 'api';
import { Recipe } from 'common/hooks/useProducer';
import exhaustivnessCheck from 'common/utils/exhaustivnessCheck';
import {
  AcceptClientTransferActions,
  CancelClientTransferRequestActions,
  ClientIncomingTransfersActions,
  ClientOutgoingTransfersActions,
  ClientTransferRequestsActions,
  CompleteClientTransferRequestActions,
  NewClientTransferActions,
  NewClientTransferRequestActions,
  UnacceptClientTransferActions,
  UserIncomingTransfersActions,
  UserOutgoingTransfersActions,
} from './actions';
import { ClientTransfersState, ClientTransferRequestsState } from './states';

// #region ClientTransfers
export const newClientTransferRecipe: Recipe<
  APIRequestState,
  NewClientTransferActions
> = (draft, action) => {
  switch (action.type) {
    case 'clients/transfers/new/started':
      draft.pending = true;
      return;

    case 'clients/transfers/new/finished':
      draft.pending = false;
      draft.success = action.success;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};

export const acceptClientTransferRecipe: Recipe<
  APIRequestState,
  AcceptClientTransferActions
> = (draft, action) => {
  switch (action.type) {
    case 'clients/transfers/accept/started':
      draft.pending = true;
      return;

    case 'clients/transfers/accept/finished':
      draft.pending = false;
      draft.success = action.success;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};

export const unacceptClientTransferRecipe: Recipe<
  APIRequestState,
  UnacceptClientTransferActions
> = (draft, action) => {
  switch (action.type) {
    case 'clients/transfers/unaccept/started':
      draft.pending = true;
      return;

    case 'clients/transfers/unaccept/finished':
      draft.pending = false;
      draft.success = action.success;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};

export const incomingClientTransfersRecipe: Recipe<
  ClientTransfersState,
  ClientIncomingTransfersActions
> = (draft, action) => {
  switch (action.type) {
    case 'clients/transfers/incoming/started':
      draft.pending = true;
      return;

    case 'clients/transfers/incoming/finished':
      draft.pending = false;
      draft.transfers = action.transfers;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};

export const incomingUserTransfersRecipe: Recipe<
  ClientTransfersState,
  UserIncomingTransfersActions
> = (draft, action) => {
  switch (action.type) {
    case 'contacts/transfers/incoming/started':
      draft.pending = true;
      return;

    case 'contacts/transfers/incoming/finished':
      draft.pending = false;
      draft.transfers = action.transfers;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};

export const outgoingClientTransfersRecipe: Recipe<
  ClientTransfersState,
  ClientOutgoingTransfersActions
> = (draft, action) => {
  switch (action.type) {
    case 'clients/transfers/outgoing/started':
      draft.pending = true;
      return;

    case 'clients/transfers/outgoing/finished':
      draft.pending = false;
      draft.transfers = action.transfers;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};

export const outgoingUserTransfersRecipe: Recipe<
  ClientTransfersState,
  UserOutgoingTransfersActions
> = (draft, action) => {
  switch (action.type) {
    case 'contacts/transfers/outgoing/started':
      draft.pending = true;
      return;

    case 'contacts/transfers/outgoing/finished':
      draft.pending = false;
      draft.transfers = action.transfers;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
// #endregion

// #region ClientTransferRequest
export const newClientTransferRequestRecipe: Recipe<
  APIRequestState,
  NewClientTransferRequestActions
> = (draft, action) => {
  switch (action.type) {
    case 'clients/transfer_requests/new/started':
      draft.pending = true;
      return;

    case 'clients/transfer_requests/new/finished':
      draft.pending = false;
      draft.success = action.success;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};

export const completeClientTransferRequestRecipe: Recipe<
  APIRequestState,
  CompleteClientTransferRequestActions
> = (draft, action) => {
  switch (action.type) {
    case 'clients/transfer_requests/complete/started':
      draft.pending = true;
      return;

    case 'clients/transfer_requests/complete/finished':
      draft.pending = false;
      draft.success = action.success;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};

export const cancelClientTransferRequestRecipe: Recipe<
  APIRequestState,
  CancelClientTransferRequestActions
> = (draft, action) => {
  switch (action.type) {
    case 'clients/transfer_requests/cancel/started':
      draft.pending = true;
      return;

    case 'clients/transfer_requests/cancel/finished':
      draft.pending = false;
      draft.success = action.success;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};

export const clientTransferRequestsRecipe: Recipe<
  ClientTransferRequestsState,
  ClientTransferRequestsActions
> = (draft, action) => {
  switch (action.type) {
    case 'clients/transfer_requests/started':
      draft.pending = true;
      return;

    case 'clients/transfer_requests/finished':
      draft.pending = false;
      draft.requests = action.requests;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
// #endregion
